<template>
  <b-row>
    <b-col cols="12">
      <index />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import Index from './Index.vue'

export default {
  components: {
    BRow,
    BCol,

    Index,
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
